import React, { useState, useEffect } from 'react';
import _axios from "../../../../httpService";
import { prefixUrl } from "../../../../utils/utilsData";
import { toast } from "react-toastify";
import CustomTable from '../../../CustomTable/CustomTable';
import Loader from '../../../Loader';
import './MarketersShare.scss';

const MarketersShare = () => {
  const [initialData, setInitialData] = useState({});
  const [isLoad, setIsLoad] = useState(false);

  const getInitialData = () => {
    _axios.get(prefixUrl() + "/insurance/?request=marketersShareTable").then((response) => {
      if (response.data.status) {
        setInitialData(response.data.data);
        setIsLoad(true)
      } else {
        toast.error(response.data.message);
      }
    })
  }

  useEffect(() => {
    getInitialData();
  }, []);

  try {
    return isLoad ?
      (
        <section className='marketers-share'>
          <CustomTable
            tableData={initialData}
            hasOperation={false}
          />
        </section>
      ) : (
        <Loader />
      );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default MarketersShare;